module.exports = __webpack_public_path__ + "img/icon-about-company.5707a534.svg";